export class SkuSearchResult {
  constructor(
    public itemId :number,
    public name: string,
    public thumbnailUrl: string,
    public countryCode: string | null,
    public country: string,
    public industry: string,
    public category?: string,
    public subCategory?: string,
    public supplier?: string,
    public brand?: string,
    public subBrand?: string,
    public packSize?: string,
    public unitsPerPack?: string,
    public unitSize?: string
  ) {}
}
 